import { QuoteInt } from "interfaces";
import styles from "./Quote.module.scss";

const Quote = ({
  className,
  quote,
  name,
  position,
  img,
  bg,
  texture,
  dark,
  reverse,
  gap,
}: QuoteInt) => {
  return (
    <section
      className={`${styles["quote-block"]} ${dark && styles.dark} ${
        gap && styles["gap"]
      } ${reverse && styles["reverse"]} anim-quote`}
    >
      <div className={`${styles["content-container"]} anim-quote-content`}>
        <h2 className={`${dark && styles.dark} bold`}>{quote}</h2>
        <p className="bold">{name}</p>
        <p>{position}</p>
      </div>
      <div
        className={`${styles["img-wrapper"]} ${styles[className]} anim-quote-img`}
      >
        <img
          src={bg}
          width={img.width}
          height={img.height}
          className={`${styles.bg}`}
          alt=""
          // loading="lazy"
        />
        <img
          src={img.src}
          width={img.width}
          height={img.height}
          className={`${styles.image}`}
          alt={name + "'s Quote"}
          // loading="lazy"
        />
      </div>
      <img
        src={texture.src}
        width={texture.width}
        height={texture.height}
        className={`${styles.texture} ${styles[className]}`}
        alt={"Textured Background"}
        // loading="lazy"
      />
    </section>
  );
};

export default Quote;
